/* Small additions around Xtra's native product and cart controls. */
(() => {
  'use strict';
  const labels = window.pawroomUi;
  if (!labels) return;
  // Preserve the current Nordic language when native routes carry /en.
  // The full document is normalized in Liquid; this covers AJAX-inserted markup.
  const locale = document.documentElement.lang.toLowerCase().split('-')[0];
  function localRoute(value) {
    if (locale === 'en' || !['sv', 'da', 'fi', 'no'].includes(locale) || !value || value[0] === '#') return value;
    let url;
    try { url = new URL(value, window.location.origin); } catch (_) { return value; }
    if (url.origin !== window.location.origin || !/^\/en(?:\/|$)/.test(url.pathname)) return value;
    url.pathname = url.pathname.replace(/^\/en(?=\/|$)/, '') || '/';
    return url.pathname + url.search + url.hash;
  }
  function localizeRoutes() {
    document.querySelectorAll('a[href], form[action]').forEach(el => {
      const attr = el.tagName === 'FORM' ? 'action' : 'href';
      const current = el.getAttribute(attr);
      const next = localRoute(current);
      if (next !== current) el.setAttribute(attr, next);
    });
  }
  function localizeControls() {
    localizeRoutes();
    for (const [original, translated] of [['Increase by 1', labels.increase], ['Decrease by 1', labels.decrease], ['quantity', labels.quantity], ['Toggle', labels.toggle]]) {
      document.querySelectorAll(`[aria-label="${original}"]`).forEach(el => {
        if (translated && original !== translated) el.setAttribute('aria-label', translated);
      });
    }
    document.querySelectorAll('a[href*="/cart/change"][href*="quantity=0"]').forEach(el => el.setAttribute('aria-label', labels.remove));
    document.querySelectorAll('a.toggle').forEach(el => {
      if (el.textContent.trim() === 'Toggle') el.textContent = labels.toggle;
    });
    const privacy = document.querySelector('#shopify-pc__banner__body-policy-link');
    if (privacy && labels.privacy) privacy.setAttribute('href', labels.privacy);
  }
  let queued = false;
  new MutationObserver(() => {
    if (queued) return;
    queued = true;
    requestAnimationFrame(() => { queued = false; localizeControls(); });
  }).observe(document.body, {childList: true, subtree: true});
  localizeControls();
  document.addEventListener('keydown', event => {
    if (event.key !== 'Escape') return;
    document.querySelectorAll('.pw-header details[open]').forEach(details => {
      details.open = false;
      details.querySelector('summary').focus();
    });
  });
  document.addEventListener('click', event => {
    document.querySelectorAll('.pw-header details[open]').forEach(details => {
      if (!details.contains(event.target)) details.open = false;
    });
  });
})();
